import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartPopulation"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 16.5H12.75V15H19.5V10.5H12.75V9H16.5V4.5H12.75V1.5H11.25V4.5H7.5V9H11.25V10.5H4.5V15H11.25V16.5H1.5V21H11.25V22.5H12.75V21H22.5V16.5ZM15 6V7.5H12.75V6H15ZM9 7.5V6H11.25V7.5H9ZM18 12V13.5H12.75V12H18ZM6 13.5V12H11.25V13.5H6ZM3 19.5V18H11.25V19.5H3ZM21 19.5H12.75V18H21V19.5Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartPopulation.vue"]]);
